import { Container, Grid } from "@material-ui/core";
import Menu from "../../Components/Menu";
import styled from "@emotion/styled";
import S2 from "../../img/S2.png";

const S1_Homepage = () => {
  const MainDiv = styled.div`
    // background-size: cover;
    // background-repeat: no-repeat;
    // background-position-y: bottom;
  `;
  const Span = styled.span`
    color: #ffffff;
    font-size: 40px;
    text-transform: uppercase;
    font-weight: 600;
    padding-bottom:10px;
    @media screen and (max-width:600px){
      font-size: 28px
    }
    @media screen and (max-width:335px){
      font-size: 24px
    }
  `;
  const P = styled.p`
    color: #ffffff;
    padding-top:30px;
    
  `;
  const Button = styled.button`
    border:none;
    height: 40px;
    color: #ffffff !important;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    display: inline-block;
    line-height: 35px;
    background-color: #B82E3C;
    `
  return (
    <MainDiv className="py-5" id="Home">
      <Container>
        <Grid
          container
          justifyContent="center"
          alignContent="center"
          alignItems="center"
          className=""
        >
          <Grid xs={12} sm={12} md={6} className="">
            <img src={S2} className="img-fluid w-100" />
          </Grid>
          <Grid xs={12} sm={12} md={1}></Grid>
          <Grid xs={12} sm={12} md={5} className="text-left">
            <h1 className="fontweight">
              <Span>
               Energy Consultancy Agriculture<br/>
              <span style={{borderBottom:'7px solid #B82E3C'}}> REAL ESTATE</span>
              </Span>
            </h1>
            <P>
              Four brothers was established 25 years ago in pakistan. we are a
              dynamic and progressive organization registered with securities
              and exchange commission of pakistan. Our dedicated services and
              support have been translated into successful track record of
              various projects and ensuring consistent growth, we have evolved
              into a well-known name representing renowned global industries in
              Pakistan. we are working with corporate national / international
              organizations as consultants. we undertake impact assessment,
              feasibility study, market research report for government;
              marketing services; brand building; market research and studies;
              government specifications; impact assessment studies and
              feasibility studies. we at four brothers are concerned with the
              future and our journey towards it. employing innovative consulting
              approaches between management and technology, we pave the way into
              the digital age for companies from......
            </P>
            <Button className="mt-2">
          <a class="px-4">
            READ MORE 
          </a>
          </Button>
          </Grid>
        </Grid>
      </Container>
    </MainDiv>
  );
};

export default S1_Homepage;
